<template>
  <v-select
    :label="label"
    :items="getSelectItems"
    :hide-details="shouldHideDetails"
    :value="data"
    @change="$emit('change', $event)"
  ></v-select>
</template>

<script>
  import { mapGetters } from 'vuex'

	export default {
		name: 'WashInstrumentInput',

		props: {
      data: {
        type: [String, Number],
        required: true
      },

      hideDetails: {
        type: Boolean,
        required: false,
        default: false
      }
    },

		data () {
			return {
        field: 'wash_instrumentID',
        label: 'Washing Machine'
			}
		},

    computed: {
      ...mapGetters('examinations', [
        'getWashInstrumentList'
      ]),

      getSelectItems () {
        return this.getWashInstrumentList.map(item => {
          return {
            text: item.wash_instrument,
            value: item.id
          }
        })
      },

      shouldHideDetails () {
        return this.hideDetails
      }
    }
	}
</script>